var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_RISK_SCORE_CHARGES_REQUEST, updateRiskScoreChargesFailure, updateRiskScoreChargesSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const onUpdateRiskScoreCharges = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const requestBody = {
                vasService: action.payload.vasService,
                baseCharge: action.payload.baseCharge,
            };
            APIIN.put(`rms/admin/vas/rate?tenantId=${action.payload.tenantId}&countryCode=${action.payload.countryCode}`, requestBody)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* updateRiskScoreWorker(action) {
    try {
        const data = yield call(onUpdateRiskScoreCharges, action);
        yield put(updateRiskScoreChargesSuccess(data));
    }
    catch (error) {
        yield put(updateRiskScoreChargesFailure(error));
    }
}
export function* watchUpdateRiskScoreCharges() {
    yield takeLatest(UPDATE_RISK_SCORE_CHARGES_REQUEST, updateRiskScoreWorker);
}
